<script lang="ts">
  import { FormGroup } from "carbon-components-svelte";
  import TextLineGroup from "../common/TextLineGroup.svelte";
  import Sections from "../common/Sections.svelte";
  import type { IText } from "src/ts/Interfaces";
  import type { Section } from "src/ts/Classes";

  export let hidden: boolean;
  export let lines: IText[];
  export let sections: Section[];
</script>

{#if !hidden}
  <div class="pane">
    <FormGroup
      legendText="Enter the texts lines you would like on your stamp"
      class="step"
    >
      {#if lines.length > 0}
        <TextLineGroup sectionName="" bind:lines />
      {/if}
      {#if sections}
        <Sections bind:sections />
      {/if}
    </FormGroup>
  </div>
{/if}
